export const STORAGE_KEYS = {
  USER_EMAIL: 'user_email',
  EDITIONS_CONTACT_FORM: 'editions_contact_form',
};

export type StorageKey = keyof typeof STORAGE_KEYS;

function isBrowser() {
  return typeof window !== 'undefined';
}

export const store = (key: StorageKey, value: string) => {
  if (!isBrowser()) return null;
  sessionStorage.setItem(STORAGE_KEYS[key], value);
};

export const retrieve = (key: StorageKey) => {
  if (!isBrowser()) return null;
  return sessionStorage.getItem(STORAGE_KEYS[key]);
};

export const remove = (key: StorageKey) => {
  if (!isBrowser()) return null;
  return sessionStorage.removeItem(STORAGE_KEYS[key]);
};
